import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '@atoms/Spinner';
import { useAuthStore } from '@store/authStore';
import type { UserRole } from '@/types';

interface RoleProtectedRouteProps {
  allowedRoles: UserRole[];
}

export function RoleProtectedRoute({ allowedRoles }: RoleProtectedRouteProps) {
  const { isAuthenticated, user, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    const redirect =
      user.role === 'admin' ? '/admin' : user.role === 'wholesaler' ? '/wholesaler' : '/restaurant';
    return <Navigate to={redirect} replace />;
  }

  return <Outlet />;
}
